export const buildReimbursementsRow = function (tab) {
    return {
        valueCells: [{ // Prorata Share - 0
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Lease Type - 1
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value ? '-' : value;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual Taxes - 2
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 3
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual Insurance - 4
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 5
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[6].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual CAM - 6
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[7].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 7
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[8].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual Mgmt. Fee - 8
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[9].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 9
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[10].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        },  { // Annual Total - 10
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[13].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 11
            editable: false,
            nameClasses: 'font-gotham font-size-9',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[14].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        },]
    }
};

export const reimbursements = {
    hasNamesColumn: false,
    rows: {},
};
